import { fetch } from '@atlassian/eoc-fetch';

import type { UiPreferences } from '../../../common/types';

export const getUiPreferencesEndpoint = (): Promise<UiPreferences> => {
	return fetch<UiPreferences>('/v1/alerts/ui-preferences');
};

export const updateUiPreferencesEndpoint = (
	data: Partial<UiPreferences>,
): Promise<UiPreferences> => {
	return fetch<UiPreferences>('/v1/alerts/ui-preferences', {
		method: 'PATCH',
		body: data,
	});
};
